import * as React from 'react';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { LayoutSize } from 'types';
import { State } from 'reducers';

import './Button.css';
import { getLayout } from 'selectors/monitoringSelectors';

export type OwnProps = {
    id: string;
    title?: string;
    titleKey?: string;
    imgSrc: string;
    size?: string;
    onClick?: () => void;
    onMouseDown?: () => void;
    onMouseUp?: () => void;
};

const RawButton = ({ id, title, titleKey = '', imgSrc, onClick, onMouseDown, onMouseUp, t, styles }: OwnProps & TranslateProps & RecomposeProps) =>
    <button
        id={ id }
        type="button"
        title={ title || t(titleKey) }
        onClick={ onClick }
        onMouseDown={ onMouseDown }
        onMouseUpCapture={ onMouseUp }
    >
        <img
            src={ imgSrc }
            style={ styles.img }
        />
    </button>
;

type StateProps = {
    size: LayoutSize;
};
type RecomposeProps = {
    styles: {
        img: React.CSSProperties;
    };
};

const mapStateToProps = (state: State) => ({
    size: getLayout(state),
});

export const Button = compose<OwnProps & TranslateProps & RecomposeProps, OwnProps>(
    skin,
    translate(),
    connect<StateProps, {}, {}>(mapStateToProps),
    withProps<RecomposeProps, StateProps & OemProps>(({ size, styles }) => ({
        styles: {
            img: {
                width: size < 16 ? '1.5em' : '1em',
                height: size < 16 ? '1.5em' : '1em',
                fill: styles.Window.color,
            },
        },
    })),
)(RawButton);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/controls/Button.tsx